import React, {useEffect, useState} from 'react'
import {Checkbox, Form, Input, Spin} from 'antd'
import {useNavigate, useParams} from 'react-router-dom'
import {useAppContext} from 'common/context/AppContext.tsx'
import {TrackerEventBean} from 'common/api/api.ts'
import {ButtonsPanel} from 'common/components/ButtonsPanel.tsx'
import {apiCall} from 'common/util/Util.tsx'
import {FormCard} from 'common/components/FormCard.tsx'
import {trackerEventApi} from 'common/api/entitiesApi.tsx'
import {CommonRoutes} from 'common/context/commonRoutes.ts'
import {AnchorsForm} from 'common/components/AnchorsForm.tsx'

const FormItem = Form.Item

type Mode = 'create' | 'edit';

interface TrackerEventFormProps {
    mode: Mode
}

const TrackerEventForm: React.FC<TrackerEventFormProps> = ({mode}) => {
    const {id} = useParams<{ id?: string }>()
    const idNum = id ? parseInt(id) : 0

    const navigateTo = useNavigate()
    const appContext = useAppContext()

    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const initialTrackerEventBean = {} as TrackerEventBean

    const loadData = () => {
        if (mode === 'edit') {
            apiCall(
                setLoading,
                appContext,
                () => {
                    return trackerEventApi.trackerEvent(idNum)
                },
                (res) => {
                    if (res && res.data) {
                        form.setFieldsValue({...res.data})
                    }
                }
            )
        }
        if (mode === 'create') {
            form.setFieldsValue({...initialTrackerEventBean})
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const onDelete = () => {
        apiCall(setLoading, appContext, () => trackerEventApi.trackerEventDelete(idNum), () => navigateTo(CommonRoutes.TRACKER_EVENT))
    }

    const onCancel = () => navigateTo(CommonRoutes.TRACKER_EVENT)

    const handleSubmit = () => {
        form.validateFields().then(values => {
            setLoading(true)
            apiCall(
                setLoading,
                appContext,
                () => {
                    if (mode === 'edit' && idNum) {
                        return trackerEventApi.trackerEventUpdate({...values}, idNum)
                    } else {
                        return trackerEventApi.trackerEventCreate({...values})
                    }
                },
                () => navigateTo(CommonRoutes.TRACKER_EVENT)
            )
        })
    }

    return (
        <Spin spinning={loading}>
            <AnchorsForm form={form} onFinish={handleSubmit}>
                <FormCard title="Tracker">
                    <FormItem name="eventType" hidden/>

                    <FormItem
                        name="name"
                        label="Name"
                        rules={[{required: true, message: 'Please input Name'}]}
                    >
                        <Input maxLength={255}/>
                    </FormItem>

                    <FormItem
                        name="withPrice"
                        label="Support Price"
                        valuePropName="checked"
                    >
                        <Checkbox/>
                    </FormItem>
                </FormCard>

                <ButtonsPanel onCancel={onCancel} onDelete={onDelete} showDelete={mode === 'edit'}/>
            </AnchorsForm>
        </Spin>
    )
}

export default TrackerEventForm